/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cap_Money_Mock_TitleInputs */

const en_cap_money_mock_title = /** @type {(inputs: Cap_Money_Mock_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lead radar`)
};

const lv_cap_money_mock_title = /** @type {(inputs: Cap_Money_Mock_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Potenciālo klientu radars`)
};

/**
* | output |
* | --- |
* | "Lead radar" |
*
* @param {Cap_Money_Mock_TitleInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const cap_money_mock_title = /** @type {((inputs?: Cap_Money_Mock_TitleInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cap_Money_Mock_TitleInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_cap_money_mock_title(inputs)
	return en_cap_money_mock_title(inputs)
});